<div class="flexible-content" style="margin-bottom: 0; background: white;" [ngClass]="loggeduser.classMediumBorder">
  <!-- LIST TYPE -->
  <div class="flexible-element flex-center-content" *ngIf="loggeduser.isArmaorUserConnected">
    <mat-form-field>
      <mat-label class="red-txt">{{'Sélectionner une liste' | translate}}</mat-label>
      <mat-select (selectionChange)="onListTypeChange($event.value)"
                  [value]="HTML_ListOptionValue"
                  [disabled]='mHTTPReqestInProgress'>
        <mat-option>None</mat-option>
        <mat-option *ngFor="let printingList of arrayTypePrintingLists" value="{{printingList}}">{{printingList}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- FORMAT -->
  <div class="flexible-element flex-center-content">
    <mat-form-field>
      <mat-label class="red-txt">{{'Sélectionner un format' | translate}}</mat-label>
      <mat-select (selectionChange)="onListFormatChange($event.value)"
                  [value]="HTML_FormatNameSelected"
                  [disabled]='mHTTPReqestInProgress'>
        <mat-option>None</mat-option>
        <mat-option *ngFor="let printingListFormat of arrayPrintingListFormat" value="{{printingListFormat.LibelleFormat}}">{{printingListFormat.LibelleFormat}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- DOWNLOAD XLS -->
  <div class="flexible-element flex-center-content">
    <button mat-raised-button
            class="button-full-width"
            [disabled]='mHTTPReqestInProgress'
            (click)="download('xls')">
      {{'Télécharger' | translate}} XLS
    </button>
  </div>

  <!-- DOWNLOAD TXT -->
  <div class="flexible-element flex-center-content">
    <button mat-raised-button
            class="button-full-width"
            [disabled]='mHTTPReqestInProgress'
            (click)="download('txt')">
      {{'Télécharger' | translate}} TXT
    </button>
  </div>
</div>

<div class="flexible-content center-elem-margin no-vert-margin" [ngClass]="loggeduser.classMediumBorder">
  <mat-expansion-panel style="margin: auto; width: 100%;" [expanded]="true">
    <mat-expansion-panel-header>
            <mat-panel-title> {{'Filtre' | translate}} </mat-panel-title>
            <mat-panel-description> {{'Click to set filter (customer, site, begining and ending date)' | translate}} </mat-panel-description>
        </mat-expansion-panel-header>

    <div class="flex-expansion-panel">

      <!-- CUSTOMER -->
      <div class="flex-content-expansion-panel" *ngIf="loggeduser.isArmaorUserConnected">
        <div>{{'Client' | translate}}</div>
        <button mat-stroked-button (click)="selectCustomer()">
          {{HTML_CustomerSelected}}
          {{ (HTML_CustomerSelected ? '' : 'Sélectionner le client' ) | translate }}
          <mat-icon>view_list</mat-icon>
        </button>
        <button mat-icon-button (click)="resetCustomer()"
                *ngIf="HTML_CustomerSelected">
          <mat-icon class="red-txt">clear</mat-icon>
        </button>
      </div>

      <!-- SITE -->
      <div class="flex-content-expansion-panel" *ngIf="loggeduser.isArmaorUserConnected || loggeduser.isCustomerConnected">
        <div>{{'Chantier' | translate}}</div>
        <button mat-stroked-button (click)="selectSite()">
          {{HTML_SiteSelected}}
          {{ (HTML_SiteSelected ? '' : 'Sélectionner le chantier') | translate }}
          <mat-icon>view_list</mat-icon>
        </button>
        <button mat-icon-button (click)="resetSite()" *ngIf="HTML_SiteSelected">
          <mat-icon class="red-txt">clear</mat-icon>
        </button>
      </div>

      <!-- Date debut -->
      <mat-form-field class="flex-content-expansion-panel">
        <input matInput [matDatepicker]="pickerBegin"
               (click)="pickerBegin.open()"
               (dateChange)="onDatePickerChange($event)"
               [placeholder]="'Date de début' | translate"
               [(ngModel)]="HTML_BeginDate"
               [disabled]='mHTTPReqestInProgress'>
        <mat-datepicker-toggle matSuffix [for]="pickerBegin"></mat-datepicker-toggle>
        <mat-datepicker #pickerBegin></mat-datepicker>
      </mat-form-field>

      <!-- Date fin -->
      <mat-form-field class="flex-content-expansion-panel">
        <input matInput [matDatepicker]="pickerEnd"
               (click)="pickerEnd.open()"
               (dateChange)="onDatePickerChange($event, true)"
               [placeholder]="'Date de fin' | translate"
               [(ngModel)]="HTML_EndDate"
               [disabled]='mHTTPReqestInProgress'>
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>
    </div>

  </mat-expansion-panel>
</div>

<!-- Progressbar -->
<ng-container *ngIf="mHTTPReqestInProgress">
    <div class="center-elem-margin">
        Loading..
        <mat-progress-bar [ngClass]="loggeduser.classBackgroundColor" mode="indeterminate"></mat-progress-bar>
    </div>
</ng-container>

<table mat-table matSort id="table" [dataSource]="HTML_TABLE_DATASOURCE"
       class=" mat-elevation-z8 cmat-add-border center-elem-margin"
       [ngClass]="htmlTableDataSource">

  <!-- Gere les valeur dynamiquement -->
  <ng-container *ngFor="let item of HTML_TABLE_HEADER; let i = index">
    <ng-container matColumnDef="{{item}}">
      <th mat-header-cell *matHeaderCellDef [mat-sort-header]="item" class="cmat-center-btn cmat-remove-lr-padding">{{HTML_DynamicHeader[i]?.Name}}</th>
      <td mat-cell *matCellDef="let element" >{{element[i]}}</td>
    </ng-container>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="HTML_TABLE_HEADER; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: HTML_TABLE_HEADER;"></tr>
</table>

<mat-paginator #TablePaginator [pageSize]="100" class="center-elem-margin"></mat-paginator>
